import { Box, Grid, Button, Link as MuiLink } from '@mui/material';
import { FiberManualRecord } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

import { isSettingEnabled } from 'utils/common';
import { MANAGE_DELIVERY_LITE_DEFAULT_TEXT, MANAGE_DELIVERY_FULL_LINK_TEXT } from 'constants/verbiage';
import { VERIFICATION_INTENT } from 'constants/verification';

function ManageDelivery(props) {
  const { classes, store, mediaQuery, trackingCode } = props;
  const { settings } = store.deliveryStore;

  const isAccessFirst =
    isSettingEnabled(settings?.enable_manage_delivery_lite) && isSettingEnabled(settings?.enable_manage_delivery_access_first);

  const handleManageDeliveryClick = () => {
    store.podStore.updateField('isPODFeedback', false);
    store.isViewPins = false;
    if (mediaQuery.isMobile) {
      store.podStore.startVerification(VERIFICATION_INTENT.MANAGE_DELIVERY);
      return;
    }
    store.deliveryStore.openDialog(1);
  };

  const items = ['Delivery instructions', 'Delivery address', 'Location pin', 'Access code'];

  return (
    <Box sx={classes.manageDeliveryContainer} my={mediaQuery.isMobile ? 2 : 3}>
      <Grid container alignItems="stretch" justifyContent="center">
        <Grid size={{ xs: 12, sm: 6 }} sx={{ ...classes.manageDeliveryInner, ...classes.manageDeliveryLeft }}>
          <Box p={2}>
            <Box sx={classes.mdTitle}>“Delivery flexibility to fit your schedule” </Box>
            <Box my={1}>Update these with our Manage Delivery feature</Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={classes.manageDeliveryInner}>
          <Box p={2}>
            <Grid align="left" container spacing={1}>
              {items.map((item) => (
                <Grid key={item} size={6} sx={classes.textOnSurfaceTextBody}>
                  <FiberManualRecord fontSize="inherit" sx={classes.mdItem} /> {item}
                </Grid>
              ))}
            </Grid>
            {isAccessFirst ? (
              <Box my={1}>
                <Button
                  component={Link}
                  to={`/${trackingCode}/access-code`}
                  sx={classes.button}
                  fullWidth
                  variant="contained"
                  color="primary"
                  disableElevation
                >
                  {settings?.manage_delivery_lite_text || MANAGE_DELIVERY_LITE_DEFAULT_TEXT}
                </Button>
                <Box mt={1} textAlign="center">
                  <MuiLink component="button" type="button" variant="body2" onClick={handleManageDeliveryClick}>
                    {MANAGE_DELIVERY_FULL_LINK_TEXT}
                  </MuiLink>
                </Box>
              </Box>
            ) : (
              <Box my={1}>
                <Button onClick={handleManageDeliveryClick} sx={classes.button} fullWidth variant="contained" color="primary" disableElevation>
                  Manage Delivery
                </Button>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default observer(ManageDelivery);
